import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth/auth.service';
import { Client } from '@core/services/client/client.model';
import { ClientService } from '@core/services/client/client.service';
import { UserService } from '@core/services/user/user.service';
import { process } from '@progress/kendo-data-query';
import { GridSettings } from '@shared/components/customized-grid/grid-settings/gird-settings.interface';
import { NgxSpinnerService } from 'ngx-spinner';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'Teranet-Client',
  templateUrl: './client.component.html',
})
export class ClientComponent implements OnInit {
  @Input() Readonly: boolean;
  clients: Client[] = [];
  gridSettings: GridSettings;

  constructor(
    private authService: AuthService,
    private clientService: ClientService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private userService: UserService
  ) { }

  public state: any = {
    skip: 0,
    take: 13,
    // Initial filter descriptor
    filter: {
      logic: 'and',
      filters: [],
    },
  };

  ngOnInit() {
    this.gridSettings = this.gridDefaultSettings();
    this.getData();
  }

  add() {
    this.router.navigateByUrl('/editclient');
  }

  getData() {
    this.spinner.show();
    this.clients = [];

    const checkReadonly = this.userService.getRolePermissionByRoleAndPage(
      this.authService.currentUserValue.role,
      this.router.url.split('/')[this.router.url.split('/').length - 1]
    );
    const getClientInfo = this.clientService.getAllClients();

    forkJoin([checkReadonly, getClientInfo]).subscribe(responses => {
      if (responses[0] != null && responses[0] != undefined) {
        if (responses[0].permissionId === 1) {
          this.Readonly = false;
        } else {
          this.Readonly = true;
        }
      }
      if (responses[1] != null && responses[1] != undefined) {
        this.clients = responses[1] as Client[];
      }
      this.gridSettings.gridData = { data: this.clients, total: this.clients?.length };
      this.spinner.hide();
    });
  }

  gridDefaultSettings(): GridSettings {
    return {
      state: this.state,
      gridData: process(this.clients, this.state),
      columnsConfig: [
        {
          field: 'id',
          filterable: true,
          hidden: false,
          includeInChooser: false,
          title: 'Id',
          width: 30,
        },
        {
          field: 'corporationCode',
          filterable: true,
          hidden: false,
          includeInChooser: false,
          routerLink: '/editclient/',
          title: 'Corporation Code',
          width: 60,
        },
        {
          field: 'corporationName',
          filterable: true,
          hidden: false,
          includeInChooser: false,
          routerLink: '/editclient/',
          title: 'Corporation Name',
          width: 120,
        },
        {
          field: 'corporationType',
          filterable: true,
          hidden: false,
          includeInChooser: false,
          routerLink: '/editclient/',
          title: 'Corporation Type',
          width: 60,
        },
        {
          field: 'isEnabled',
          filter: 'boolean',
          filterable: true,
          hidden: false,
          title: 'Is Enabled',
          type: 'boolean1',
          width: 50,
        },
      ],
    };
  }
}
